import { IconButton } from '@rikstv/play-common/src/components/button';
import { CloseIcon } from '@rikstv/play-common/src/icons';
import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

import styles from './PlayerErrorContainer.module.css';

const PlayerErrorContainer: FCC<{ onCloseModalPlayer?: () => void }> = ({ children, onCloseModalPlayer }) => (
  <div className={styles.container}>
    <div className={styles.contentWrapper}>{children}</div>
    {onCloseModalPlayer && (
      <IconButton
        className={styles.modalCloseButton}
        id="player-controls-close-modal"
        buttonStyle="tertiary"
        icon={CloseIcon}
        ariaLabel="Steng spiller"
        onClick={onCloseModalPlayer}
      />
    )}
  </div>
);

export { PlayerErrorContainer };
